module.exports = __webpack_public_path__ + "img/ir.f2a99126.svg";